function aiStringOrSecretManagerInput($parse, $templateCache) {
  $templateCache.put(
    'string-or-secret-manager-input.html',
    [
      '<div class="schema-form-string-or-secret-manager">',
      '  <label class="control-label" for="{{ inputId }}">',
      '    {{ form.title }}',
      '    <span ng-if="form.required" class="required-asterisk"> *</span>',
      '  </label>',
      '  <input',
      '    id="{{ inputId }}"',
      '    class="form-control"',
      '    type="{{ inputType }}"',
      '    ng-model="currentValue"',
      '    ng-change="updateValue()"',
      '    ng-readonly="form.readonly"',
      '    autocomplete="off"',
      '  />',
      '</div>'
    ].join('\n')
  );

  function link(scope, elem, attrs) {
    const getter = $parse(attrs.ngModel);
    const setter = getter.assign;

    scope.inputType = scope.form?.redacted ? 'password' : 'text';
    scope.inputId = scope.form?.key ? scope.form.key.slice(-1)[0] : '';

    scope.updateValue = function () {
      setter(scope, { type: 'manual', value: scope.currentValue });
    };

    scope.$watch(
      function () {
        return readValue(getter(scope));
      },
      function (nextValue) {
        if (nextValue !== scope.currentValue) {
          scope.currentValue = nextValue;
        }
      }
    );
  }

  function readValue(modelValue) {
    if (modelValue == null) return '';
    if (typeof modelValue === 'string') return modelValue;
    return modelValue.value || '';
  }

  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'string-or-secret-manager-input.html',
    link: link
  };
}

aiStringOrSecretManagerInput.$inject = ['$parse', '$templateCache'];
export default aiStringOrSecretManagerInput;
